import { Chip } from "@mui/material";

export const dashboardColumns = [
  {
    field: "id",
    headerName: "ID",
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "waterBillRefNumber",
    headerName: "Réf. Facture Eau",
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "selectedDate",
    headerName: "Date Sélectionnée",
    flex: 1,
    type: "date",
    align: "center",
    headerAlign: "center",
  },
  {
    field: "recetteDate",
    headerName: "Date Recette",
    flex: 1,
    type: "date",
    align: "center",
    headerAlign: "center",
    renderCell: (params) => params.value || "—",
  },
  {
    field: "firstName",
    headerName: "Prénom",
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "lastName",
    headerName: "Nom",
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "currentIndex",
    headerName: "Index Actuel",
    flex: 1,
    type: "number",
    align: "center",
    headerAlign: "center",
  },
  {
    field: "consommation",
    headerName: "Consommation",
    flex: 1,
    type: "number",
    align: "center",
    headerAlign: "center",
  },
  {
    field: "paidAmount",
    headerName: "Montant Payé",
    flex: 1,
    type: "number",
    align: "center",
    headerAlign: "center",
    renderCell: (params) =>
      `${Number(params.value || 0).toFixed(2)} CFA`,
  },
  {
    field: "paymentStatus",
    headerName: "Statut Paiement",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => {
      const isPaid = params.value === "payé";

      return (
        <Chip
          label={isPaid ? "Payé" : "Impayé"}
          color={isPaid ? "success" : "error"}
          size="small"
        />
      );
    },
  },
];